import { render, staticRenderFns } from "./popupView.vue?vue&type=template&id=2233fb35&scoped=true"
import script from "./popupView.vue?vue&type=script&lang=js"
export * from "./popupView.vue?vue&type=script&lang=js"
import style0 from "./popupView.vue?vue&type=style&index=0&id=2233fb35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2233fb35",
  null
  
)

export default component.exports